import {
  createRouter as createTanStackRouter,
  isNotFound,
  rootRouteId,
  type RouterHistory,
} from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';

/** Whether a loaded router is showing "not found": no route matched, or a loader threw notFound(). */
export function showsNotFound(router: ReturnType<typeof createRouter>): boolean {
  const { matches } = router.state;
  return matches.every((m) => m.routeId === rootRouteId) || matches.some((m) => isNotFound(m.error));
}

export function createRouter(history?: RouterHistory) {
  return createTanStackRouter({
    routeTree,
    history,
    // Pages are full documents (links are plain <a> tags), matching the Webflow site.
    defaultPreload: false,
    scrollRestoration: false,
    trailingSlash: 'never',
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createRouter>;
  }
}
